import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 302px;
  height: 312px;
  gap: 12px;
    cursor: pointer;
`;

const GridImage = styled.img`
  width: 100%;
  height: 230px;
  min-height: 230px;
  max-height: 230px;
  object-fit: contain;
  border-radius: 12px;
`;

const GridTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #212121;
  line-height: 22px;
`;

const AddraddWrap = styled.div`

`

const GridDescription = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
`;

const GridDetailDescription = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  color: #666666;
`;

function GridPost({ image, title, description, descriptionDetail, onClick }) {
    console.log('//image',image);
  return (
    <Container onClick={onClick}>
      <GridImage src={image} alt='Grid Image' />
      <GridTitle>{title}</GridTitle>
      <AddraddWrap>
        <GridDescription>{description}</GridDescription>
        <GridDetailDescription>{descriptionDetail}</GridDetailDescription>
      </AddraddWrap>
    </Container>
  );
}

export default GridPost;
